import { Component, Input, ViewEncapsulation } from '@angular/core';

import { EmailButtonComponent } from '../../components/email-button/email-button.component';
import { EmailLayoutComponent } from '../../components/email-layout/email-layout.component';
import { EmailLinkComponent } from '../../components/email-link/email-link.component';
import { EmailMarginComponent } from '../../components/email-margin/email-margin.component';
import { EmailMessageHeaderComponent } from '../../components/email-message-header/email-message-header.component';
import { EmailRecruiteeLogoComponent } from '../../components/email-recruitee-logo/email-recruitee-logo.component';
import { EmailTextComponent } from '../../components/email-text/email-text.component';
import { SsrMarkToUnwrapDirective } from '../../directives/ssr-markto-unwrap.directive';
import { WrappedValue } from '../../mailgun/wrap-value';

@Component({
  standalone: true,
  selector: 'email-texting-campaign-request-notification-template',
  styleUrls: ['../../global-styles.less', './texting-campaign-request-notification.component.less'],
  templateUrl: './texting-campaign-request-notification.component.html',
  imports: [
    EmailMarginComponent,
    EmailLayoutComponent,
    EmailRecruiteeLogoComponent,
    EmailMessageHeaderComponent,
    EmailTextComponent,
    EmailButtonComponent,
    EmailLinkComponent,
  ],
  hostDirectives: [SsrMarkToUnwrapDirective],
  encapsulation: ViewEncapsulation.None,
})
export class TextingCampaignRequestNotificationTemplateComponent {
  @Input({ required: true })
  public data: WrappedValue<TextingCampaignRequestNotificationTemplateData>;
}

export type TextingCampaignRequestNotificationTemplateData = {
  title: string;
  p1: string;
  button_link: string;
  button_text: string;
  footer: string;
  support_email: string;
};

export const TextingCampaignRequestNotificationTemplateMocks: TextingCampaignRequestNotificationTemplateData[] =
  [
    {
      title: 'A2P 10DLC registration failed',
      p1: 'The A2P 10DLC registration for company {Company_name} has failed. Please contact our Support team to find out more.',
      button_link: 'http://recruitee.com',
      button_text: 'Go to Recruitee',
      footer: 'Need help?',
      support_email: 'support@recruitee.com',
    },
  ];
